export enum ChangeErrorType {
  ChangeBrowser = 'changeBrowser_error',
  ChangeDevice = 'changeDevice_error',
}
